<template>
  <div class="container" v-if="res" :style="viewStyle">
    <div class="content">
      <div class="coupon">
        <div class="left">
          <img class="image" :src="res.src" alt="" />
        </div>
        <div class="right">
          <div class="name">{{ res.name }}</div>
          <div class="date">
            <template v-if="res.byDay">领取后{{ res.byDay }}天内可用</template>
            <template v-else>{{ res.beginTime }} - {{ res.endTime }}</template>
          </div>
          <div class="view" v-if="!fromPackage">
            <div class="price" v-price="res.price"></div>
            <div class="marking-price">￥{{ res.markingPrice }}</div>
          </div>
        </div>
      </div>
      <div class="bottom-view">
        <div class="detail">
          <div class="title">券详情</div>
          <div class="item type">
            <div class="left">券类型</div>
            <div class="right">
              <template v-if="res.couponType === 1">满减券</template>
              <template v-else-if="res.couponType === 2">运费券</template>
              <template v-else-if="res.couponType === 3">兑换券</template>
            </div>
          </div>
          <div class="item money" v-if="res.couponType !== 3">
            <div class="left">券面额</div>
            <div class="right">
              <span class="value">{{ res.couponValue }}元</span>
              <span class="condition">（满{{ res.minimumAmount }}元可用）</span>
            </div>
          </div>
        </div>
        <div class="rule" v-if="res.ruleDesc">
          <div class="title rule-title">规则说明</div>
          <div v-html="res.ruleDesc"></div>
        </div>
        <div class="scope">
          <div class="title scope-title">适用范围</div>
          <div class="head">
            <div class="view" v-if="res.range.left">
              {{ res.range.left }}
            </div>
            <div class="view" v-if="res.range.right" @click="onJumpTo">
              {{ res.range.right }}
              <img
                class="arrow"
                src="https://img.chinabeego.com/uploadfile/2022/11/5/16676334568288138706542971608.png"
                alt=""
              />
            </div>
          </div>
          <div class="goods" v-if="res.joinRangeType === 4">
            <div
              class="item"
              v-for="(item, index) of res.goodsList"
              :key="index"
              @click="onJumpToGoodsDetail(item)"
            >
              <img class="image" :src="item.goodsImg" alt="" />
            </div>
          </div>
          <div class="stores" v-else-if="branch.show">
            <div class="item-box">
              <div
                class="item"
                v-for="(item, index) of branch.list"
                :key="index"
                @click="onJumpToStore(item)"
              >
                <div class="left">
                  <img class="image" :src="item.branchLogo" alt="" />
                </div>
                <div class="right">
                  {{ item.branchName }}
                </div>
              </div>
            </div>
            <div class="see" v-if="!branch.isEmpty" @click="onSeeMoreClick">
              点击查看更多店铺
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer" v-if="!fromPackage">
      <div class="left">
        <div class="price" v-price="res.price"></div>
      </div>
      <div :class="['btn', res.btn.status]" @click="onButtonClick">
        {{ res.btn.name }}
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/utils/common';
export default {
  data() {
    const { id, from } = this.$route.query;
    return {
      id,
      res: null,
      fromPackage: from === 'package',
      branch: {
        list: [],
        isEmpty: false,
        loading: false,
        pageIndex: 2,
        pageSize: 20,
        initPageSize: 20
      }
    };
  },
  computed: {
    viewStyle() {
      return {
        height: document.documentElement.clientHeight + 'px'
      };
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const req = this.http({
        method: 'get',
        url: `order/coupon/findCouponDetail/${this.id}`
      });
      req.then((data) => {
        if (data.code === 200 && (data = data.data)) {
          const { branch } = this;
          const format = (v) => (v ? v.replace(/-/g, '.') : '');
          const btn = {};
          const range = {};
          switch (data.couponBtnStatus) {
            case 'CLOSED':
              btn.status = 'finish';
              btn.name = '已结束';
              break;
            case 'SOLD_OUT':
              btn.status = 'sold-out';
              btn.name = '已售罄';
              break;
            default:
              btn.name = '立即购买';
              break;
          }
          switch (data.joinRangeType) {
            case 1: // 全部商品
              range.left = '全场商品可用';
              break;
            case 4: // 商品
              range.left = '指定商品可用';
              break;
            case 7: // 秒杀商品
              range.left = '指定秒杀活动可用';
              break;
            case 2: // 店铺
            case 6: // 核销店铺
              range.left = '指定店铺可用';
              branch.show = true;
          }
          if (data.couponType !== 3) {
            range.right = '查看可用商品列表';
          }
          data.btn = btn;
          data.range = range;
          data.beginTime = format(data.beginTime);
          data.endTime = format(data.endTime);
          data.src = data.indexImageKey || this.defaultSrc;
          branch.list = data.branchList ? data.branchList.list : [];
          branch.isEmpty = branch.list.length < branch.initPageSize;
          this.res = data;
        }
      });
      req.finally(this.$loading.hide);
    },
    onSeeMoreClick() {
      const { branch } = this;
      if (branch.loading || branch.isEmpty) return;
      branch.loading = true;
      this.$loading.show();
      const req = this.http({
        method: 'post',
        url: 'order/coupon/findRelBranchList',
        parmes: {
          pageIndex: branch.pageIndex,
          pageSize: branch.pageSize,
          couponId: this.res.id
        }
      });
      req.then((data) => {
        if (data.code === 200 && (data = data.data)) {
          branch.list = branch.list.concat(data.list);
          branch.isEmpty = data.list.length < branch.pageSize;
          branch.pageIndex++;
        }
      });
      req.finally(() => {
        branch.loading = false;
        this.$loading.hide();
      });
    },
    onJumpTo() {
      const { res } = this;
      const str1 = `?couponId=${res.id}&minimumAmount=${res.minimumAmount}`;
      const str2 = `&couponValue=${res.couponValue}&goodTypeDesc=${res.joinGoodsType}`;
      utils.jumpToNewPage({
        url: window.location.origin + '/h5user/goodsCouponList' + str1 + str2,
        noTitle: '1',
        barColor: '#FFFFFF'
      });
    },
    onJumpToStore(item) {
      utils.jumpToNewPage({
        url: location.origin + `/h5user/brandindex?id=${item.id}`,
        action: { tm: 4090100, tp: { branchId: item.id } },
      })
    },
    onJumpToGoodsDetail(item) {
      utils.jumpToNewPage({
        url: location.origin + `/h5user/newcommoditydetails?id=${item.id}`,
        action: { tm: 4030100, tp: { goodsId: item.id } },
      })
    },
    /**
     * 跳转APP确认订单页
     */
    onButtonClick() {
      if (this.res.btn.status) return;
      const tp = {
        couponId: this.id,
        count: 1,
        couponType: 1
      };
      utils.nativeMethod({ tm: 4120102, tp });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  font-family: PingFangSC-Regular, PingFang SC;
  font-size: 24px;
  height: 100vh;
  background-image: linear-gradient(180deg, #ffa2a2 0%, #f2f2f2 100%);
  background-size: 100% 560px;
  background-repeat: no-repeat;
  background-color: #f2f2f2;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  .content {
    flex: 1;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding: 24px;
    > .coupon::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: -42px;
      z-index: 1;
      height: 44px;
      background-image: url('https://img.chinabeego.com/uploadfile/2022/11/5/16676322457695550355303734017.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
  .footer {
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #ffffff;
    box-shadow: 0px -4px 8px 0px rgba(216, 220, 230, 0.5);
    padding: 0 24px;
    /deep/ .price {
      span {
        color: #e15554;
        font-size: 36px;
      }
      i {
        font-size: 24px;
        font-weight: normal;
      }
    }
    .btn {
      background: linear-gradient(
        90deg,
        var(--productDetailColorP1) 0%,
        var(--productDetailColorP2) 100%
      );
      color: var(--gdcartextColor2);
      width: 185px;
      height: 80px;
      border-radius: 40px;
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .btn.finish,
    .btn.sold-out {
      background: #d1d1d1;
      color: #ffffff;
    }
  }
}
.coupon {
  display: flex;
  height: 202px;
  background-color: #ffffff;
  border-radius: 8px 8px 0 0;
  position: relative;
  .left {
    padding-left: 24px;
    padding-top: 32px;
  }
  .image {
    display: block;
    width: 160px;
    height: 160px;
  }
  .right {
    flex: 1;
    position: relative;
    padding: 24px 24px 0 24px;
  }
  .name {
    font-size: 30px;
    font-weight: bold;
    font-family: PingFangSC-Medium, PingFang SC;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 38px;
  }
  .date {
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #b4b4b4;
    margin-top: 12px;
    line-height: 1.3;
  }
  .view {
    position: absolute;
    left: 24px;
    right: 0;
    bottom: 0;
    z-index: 1;
    display: flex;
    align-items: flex-end;
  }
  /deep/.price {
    span {
      font-size: 40px;
      color: #e15554;
    }
    i {
      font-size: 28px;
      font-weight: normal;
    }
  }
  .marking-price {
    color: #b4b4b4;
    text-decoration: line-through;
    font-size: 22px;
    margin-left: 2px;
    margin-bottom: 2px;
  }
}
.bottom-view {
  margin-top: 42px;
  padding-top: 28px;
  background-color: #ffffff;
  border-radius: 0 0 8px 8px;
  .title {
    color: #3b3a38;
    font-size: 32px;
    font-weight: 500;
    font-family: PingFangSC-Medium, PingFang SC;
    padding: 8px 0;
  }
}

.detail {
  padding: 24px;
  .item {
    font-size: 26px;
    display: flex;
    line-height: 34px;
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0;
    }
    .left {
      width: 114px;
      color: #808080;
    }
    .right {
      flex: 1;
    }
  }
  .type .right {
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
  }
  .money .value {
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #e15554;
  }
  .money .condition {
    font-size: 22px;
    color: #b4b4b4;
  }
}
.rule {
  padding: 24px;
}
.scope {
  padding: 24px;
  .head {
    display: flex;
    justify-content: space-between;
    font-size: 26px;
    color: #808080;
  }
  .view {
    height: 48px;
    display: flex;
    align-items: center;
  }
  .arrow {
    display: block;
    width: 48px;
    height: 48px;
  }
  .shop {
    color: #4088ee;
    font-size: 26px;
    line-height: 34px;
  }
  .goods {
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
    .item {
      width: 156px;
      height: 156px;
      border-radius: 8px;
      overflow: hidden;
    }
    .image {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .stores {
    .item-box {
      display: flex;
      flex-wrap: wrap;
      margin-top: 16px;
    }
    .item {
      flex-shrink: 0;
      width: calc(50% - 12px);
      height: 122px;
      margin-right: 12px;
      margin-bottom: 12px;
      display: flex;
      padding: 24px 12px;
      box-sizing: border-box;
      box-shadow: 0px 0px 8px 0px rgba(216, 220, 230, 0.5);
      border-radius: 8px;
    }
    .left {
      flex-shrink: 0;
      position: relative;
      &::after {
        content: ' ';
        position: absolute;
        left: 0;
        top: 0;
        pointer-events: none;
        box-sizing: border-box;
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
        width: 199.8%;
        height: 199.7%;
        transform: scale(0.5, 0.5);
        border: 1px solid #e1e1e1;
        z-index: 2;
      }
    }
    .image {
      display: block;
      width: 112px;
      height: 74px;
      object-fit: contain;
      position: relative;
    }
    .right {
      padding-left: 12px;
      font-size: 28px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      line-height: 36px;
      height: 72px;
    }
    .see {
      padding-top: 24px;
      padding-bottom: 12px;
      color: #4088ee;
      font-size: 26px;
      text-align: center;
    }
  }
}
</style>
